import styled from 'styled-components';
import { Box } from '@mui/material';

export const CreateRequestWrapper = styled.div`
background-color: #fff;
padding: 37px 37px 80px 51px;
border: 1px solid #1B4A83;
border-radius: 5px;
margin-top: 20px;
.createrequestContainer{
.requestForm{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 28px;

    h6{
        font-size: 16px;
        color: #1B4A83;
        font-weight: 600;
    
    }
    .bannerimage
    {
        margin-right:10px;
    }
    .requestformLeft{
        display: flex;
        align-items: center;
        gap: 15px;
        span{
            font-size: 14px;
            color: #B4B4B4;
            text-decoration: underline;
            cursor: pointer;
        }
        button{
            border-radius: 5px;
            background-color: #B4B4B4;
            text-transform: capitalize;

        }
    }
    .requestformLeftTwo{
        display: flex;
        align-items: center;
        text-align: left;
        width:30%;
        gap: 15px;
        span{
            font-size: 14px;
            color: #B4B4B4;
            text-decoration: underline;
            cursor: pointer;
        }
       .iconone
       {
        color: #1B4A83;
       }
       .icontwo
       {
        color: #239155;
       }
        .btnreplace{
            border-radius: 5px;
            color: #1B4A83;
            text-transform: none;

        }
        .btnview{
            border-radius: 5px;
            color: #239155;
            text-transform: none;

        }
    }
}
.formdataContainer{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 34px 10px 0;
    width: 100%;

    .formdataField{
        width: 25%;
        padding-bottom: 30px;
        text-align: left;
    label{
        font-weight: 700;
        font-size:16px;
    }
    }

.formInput{
    margin-top: 16px;
    font-size:14px;
    .MuiInputBase-input{
        height: 0.2375em;
        background-color: #E4E4E4;
        border-radius: 5px;
        font-weight: 600;
        font-size:14px;
    }
    .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
        opacity: 1;
        -webkit-text-fill-color: rgba(0, 0, 0, 0.87);
    }
}

}
.secondAccordian {
    margin-top: 25px;

    .formdataFieldOne{
        width: 100%;
        text-align: start;
        min-height: 100px;

        label{
            font-size: 16px;
            color: #080909;
            font-weight: 700;
            padding-left: 3px
        }
        .infoIcon{
            // color: #1B4A83;
            font-size: 18px;
            margin: -5px 5px;
        }
        .formInput{
            margin-top: 16px;
            width: 95%;
            font-size:14px;
            margin: 16px 0 0 0;
            .MuiInputBase-input{
                height: 0.4375em;
                background-color: #fff;
                border-radius: 5px;
            }
        }
        
    }
    .formdataFieldTwo{
        width: 50%;
        text-align: start;
        min-height: 100px;

        label{
            font-size: 16px;
            color: #080909;
            font-weight: 700;
            padding-left: 3px
        }
        .infoIcon{
            // color: #1B4A83;
            font-size: 18px;
            margin: -5px 5px;
        }
        .formInputTwo{
            margin-top: 16px;
            width: 90%;
            font-size:14px;
            margin: 16px 0 0 0;
            .MuiInputBase-input{
                height: 0.4375em;
                background-color: #fff;
                border-radius: 5px;
            }
        }
        
    }
    




    .formdataFieldThree{
        width: 25%;
        padding: 25px 0;
        min-height: 100px;
        text-align: left;
        svg{
            // color: rgb(27, 74, 131);
            font-size: 18px;
            margin: -5px 5px;
        }
        .formInputThree{
            margin-top: 28px;
            width: 80%;
            font-size:14px;
            .MuiInputBase-input{
                background-color: #fff;
                height: 0.4375em;
                border-radius: 5px;
            }
           
        }
        .formInputThreeSecond{
            margin-top: 16px;
            width: 80%;
            font-size:14px;
            .MuiInputBase-input{
                background-color: #fff;
                height: 0.4375em;
                border-radius: 5px;
            }
        }
        .formInputThreeThird{
            width: 80%;
            margin-top: 7px;
            font-size:14px;
            .MuiInputBase-input{
                background-color: #fff;
                height: 0.4375em;
                border-radius: 5px;
            }
        }
        .formInputThreeFour{
            margin-top: 28px;
            width: 80%;
            font-size:14px;
            .MuiInputBase-input{
                background-color: #fff;
                height: 0.4375em;
                border-radius: 5px;
            }
        }
        .uploadFile{
            display: flex;
            
        }
        .fileReButton
        {
            margin-top: 28px;
            margin-right:30px;
            margin-left:10px;
            max-height: 40px;
            text-align: center;
            font-weight:600;
            border-radius: 5px;
            text-transform: none;
            color: #fff;
            width:40%;
        }
        .fileName {
            margin-top: 28px;
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        .fileButton
        {
            margin-top: 28px;
            color: #1976d2;
            margin-right:30px;
            max-height: 40px;
            text-align: center;
            font-weight:600;
            border-radius: 5px;
            text-transform: none;
        }
        label{
            display: block;
            font-size: 16px;
            color: rgb(8, 9, 9);
            font-weight: 700;
            font-size:16px;
            max-height: 32px;
            padding-left: 3px
        }
        .css-1u3bzj6-MuiFormControl-root-MuiTextField-root{
            width: 80%;
        }
        .inputSelect {
            padding-top: 16px;
         .customDropdown{
            width: 80%;
            margin-top: 12px;
            .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select{
                height: 0.4375rem;
                min-height: auto;
            }
            .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root{
                line-height: 0.5;
            }
            
        }
    }
    .checkboxInput{
        margin-top: 50px;
        .css-j204z7-MuiFormControlLabel-root .MuiFormControlLabel-label.Mui-disabled {
           color:#000000;
          
        }
        .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-disabled {
            color: #1976d2;
        }
    }
    }
}
.thirdAccordian{
    margin-top: 25px;
    .thirdAccordianContainer{
        padding: 25px;
        h6{
            text-align: start;
            color: #080909;
            font-size: 16px;
            font-weight: 600;
        }
        .d-flex{
     flex-wrap: wrap;
            .checkboxInput{
                width: 30%;
                .css-j204z7-MuiFormControlLabel-root .MuiFormControlLabel-label.Mui-disabled {
                   color:#000000;
                  
                }
                .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-disabled {
                    color: #1976d2;
                }
            }
        }

    }
    .accordianBottom{
        padding: 25px;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        .bottomInputs{
           
            width: 25%;
            text-align: start;
            label{
                display: block;
                font-weight: 700;
                font-size:16px;
            }
            .formInputFour{
                padding-top: 16px;
                font-size:14px;
                .MuiInputBase-input{
                    background-color: #fff;
                    height: 0.4375em;
                    border-radius: 5px;
                }
                
            
            }
            .bottomInputSelect {
                padding-top: 16px;
             .customDropdown{
                width: 80%;
    
                .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select{
                    height: 0.4375rem;
                    min-height: auto;
                }
                .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root{
                    line-height: 0.5;
                }
                
            }
        }

       
    }
    button{
        margin-top: 25px;
        text-transform: capitalize;
         margin-left:auto;
              }

}


}
span.error {
    color: #FF0000;
    line-height: 2;
    font-weight: 400;
}
span.red {
    color: #ff0000;
}
.errorInput {
    border: 1px solid #ff0000;
    border-radius: 5px;


  }

  .correctInput {
    border: 1px solid black;
    border-radius: 5px;
  }

`;

export const ViewBoxWrapper = styled(Box)`
margin-top: 52px;
margin-bottom: 40px;
.viewTableContainer{
    .d-flex{
        justify-content: space-between;

        h4{
            color: #1B4A83;
            font-size: 20px;
            font-weight: 600;
        
        }
        button{
           
            text-transform: capitalize;
            border-radius: 5px;
            svg{
                padding-right: 6px;
                font-size: 15px;
            }
  
        }
        .editBtn{
            button{
                background-color: #1B4A83;
            }
        }
    }
}
.viewTableContent{
    margin-top: 20px;
    thead{
        background-color: rgb(27, 74, 131);
        th{
            color: #fff;
            font-size: 14px;
            font-weight: 600;
            padding: 10px 37px;
        }
    }
        tbody{
          tr{
            td{
                padding: 10px 37px;
            }
          }
        }
    
}


`;

export const CalculationWrapper = styled.div`
margin-bottom: 130px;
.calculationContainer{
    h4{
        font-size: 20px;
        color: #1B4A83;
        font-weight: 600;
        text-align: start;
        padding-bottom: 10px;

        span{
            font-weight: 400; 
        }
    }
    .calculationContent{
        background-color: #fff;
        border-radius: 0px 0px 5px 5px;
        .d-flex{
            padding: 18px 51px;
            gap: 90px;
            .heading{
h6{

    font-size: 18px;
    color: #1B4A83;
    text-align: start;


}
span{
    color: #2A2725;
    font-size: 18px;
    font-weight: 500;

}
            }
        }
    }
}


`;